import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgReduxModule } from '@angular-redux/store';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { StopsActions, StopsFacade } from './+state';
import { CoreUiModule } from './../core-ui/core-ui.module';
import { AllStopsComponent } from './components/all-stops/all-stops.component';
import { SingleStopSelectComponent } from './components/single-stop-select/single-stop-select.component';
import { StopsSelectComponent } from './components/stops-select/stops-select.component';
import { EffectsModule } from '@ngrx/effects';
import { StopsService } from './stops.service';

@NgModule({
    imports: [CommonModule, CoreModule, CoreUiModule, NgReduxModule, EffectsModule.forRoot([]), TranslateModule],
    declarations: [SingleStopSelectComponent, AllStopsComponent, StopsSelectComponent],
    providers: [StopsService, StopsActions, StopsFacade],
    exports: [SingleStopSelectComponent, AllStopsComponent, StopsSelectComponent]
})
export class StopsModule {}
